import React from 'react'

export default function PopupCompitability({customComponent, member, team, backgroundImageUrl, impact, impactDesc, attrData}) {
  return (
    <div>
        {customComponent}
        {/* <h6>Compatibility of {member} with the {team}</h6>
        <div style={{backgroundImage: `url(${backgroundImageUrl})`, backgroundSize: 'cover', textAlign: 'left', padding: '25px 5px 20px 70px'}}>
            <span style={{color: 'white', fontSize: 18, fontWeight: 'bold', textTransform: 'uppercase'}}>
                {impact}
            </span>
            <span style={{color: 'white', fontSize: 11, fontStyle: 'italic', fontWeight: 'normal'}}>
                {impactDesc}
            </span>
        </div>
        <div>
            <div style={{backgroundImage: `url()`, padding: '10px 5px 10px 20px', backgroundSize: 'cover', textAlign: 'left', marginTop: 3, color: 'black'}}>
                <span style={{fontWeight: 'bold'}}>
                    Time sense : 
                </span>
                <span style={{fontSize: 12}}>
                    Timing their decisions well and striking at the right time
                </span>
            </div>
        </div> */}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Compatibility/detailPopup/popupCompitability.js